import { Skeleton } from '@/components/ui/skeleton';

/** Loading placeholder for a full-page editor (header card + main column + right rail). */
export function EditorSkeleton() {
	return (
		<div className="flex flex-col gap-4">
			<Skeleton className="h-24 w-full rounded-lg" />
			<div className="grid grid-cols-1 gap-4 lg:grid-cols-[1fr_320px]">
				<Skeleton className="h-[30rem] rounded-lg" />
				<Skeleton className="h-80 rounded-lg" />
			</div>
		</div>
	);
}
